import dynamic from "next/dynamic";
import WhatsNewInnerPageSideBySideTextAndAssetConfig from "./whats-new-inner-page-side-by-side-text-and-asset-config";
import WhatsNewInnerPageSideBySideTextAndAssetAdvancedConfig from "./whats-new-inner-page-side-by-side-text-and-asset-advanced-config";
const WhatsNewInnerPageSideBySideTextAndAssetComponent = dynamic(()=>import("./whats-new-inner-page-side-by-side-text-and-asset-component"));
export default {
    WhatsNewInnerPageSideBySideTextAndAssetComponent,
    WhatsNewInnerPageSideBySideTextAndAssetConfig,
    WhatsNewInnerPageSideBySideTextAndAssetAdvancedConfig
};
